module.exports = __webpack_public_path__ + "toBride2-we-p-n.27fbcace.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-p-n.jpg
// module id = Lb0p
// module chunks = 0